export default "__VITE_ASSET__CPTW_ZSr__"